import React, { useEffect } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ProviderMatchProviderV9, PMCConfig } from '@kyruus/types';

import {
  CardContentContainer,
  CardContentHeader,
  CardContentHorizontalList,
  CardContentHorizontalListItem,
  ProviderInformationCard
} from './styles';
import { isSummaryDataConfigured, pruneIgnoredValues } from '../../lib/utils';
import messages from '../../lib/messages';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

const Languages = ({
  provider,
  config,
  shouldSkipRender,
  intl
}: {
  provider: ProviderMatchProviderV9;
  config: PMCConfig;
  shouldSkipRender: (component: string) => void;
} & WrappedComponentProps): React.ReactElement | null => {
  const renderItems = pruneIgnoredValues(
    provider,
    'languages',
    config
  ).languages;

  const skipRendering =
    !isSummaryDataConfigured('languages', config) ||
    !Array.isArray(provider.languages) ||
    provider.languages.length === 0;

  useEffect(() => {
    if (skipRendering) {
      // callback to the parent component to skip rendering
      shouldSkipRender('languages');
    }
  }, [skipRendering]);

  // do not render if summary_data field not present or data not present or is empty
  if (skipRendering) {
    return null;
  }

  return (
    <ProviderInformationCard>
      <CardContentContainer>
        <CardContentHeader>
          {intl.formatMessage(messages.languagesHeader)}
        </CardContentHeader>
        <CardContentHorizontalList>
          {renderItems.map((item: string, index: number) => (
            <CardContentHorizontalListItem
              key={`${(item || '').toString()}-${index}`}
            >
              {item}
            </CardContentHorizontalListItem>
          ))}
        </CardContentHorizontalList>
      </CardContentContainer>
    </ProviderInformationCard>
  );
};

export default withErrorBoundary(injectIntl(Languages));
